var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score"},[_c('span',{staticClass:"label"},[_vm._v("Start score:")]),_vm._v(" "),_c('b-form-input',{attrs:{"value":_vm.startscore},on:{"input":_vm.changeStartScore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }